module.exports = __webpack_public_path__ + "static/deals-for-you-profile-97fa666198338a5fc8e1a03a9027a96e.png";